
<ng-template #view ></ng-template>
